import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.jsx";
import "./index.css";
import FunctionalContext from "./components/context/FunctionalContext.jsx";

createRoot(document.getElementById("root")).render(
  <>
    <HelmetProvider>
      <FunctionalContext>
        <App />
      </FunctionalContext>
    </HelmetProvider>
  </>,
);
